// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"_fd374a8","withIcon":"_4c6a253"};